import * as yup from 'yup';

import {
	firstNameValidator,
	lastNameValidator,
	phoneValidator,
} from '@mopla/utils';

export const PersonalDetailsValidationSchema = yup.object().shape({
	firstName: firstNameValidator(),

	surname: lastNameValidator(),

	dateOfBirth: yup
		.string()
		.test('is-valid-date', 'dateOfBirth.required', function () {
			const { day, month, year } = this.parent;
			return !!day && !!month && !!year;
		}),
	phoneNumber: phoneValidator(),
	street: yup.string().required('street.required').max(100, 'street.max'),
	streetNumber: yup
		.string()
		.trim()
		.required('streetNumber.required')
		.max(6, 'streetNumber.max'),
	postCode: yup
		.string()
		.trim()
		.required('postCode.required')
		.max(20, 'postCode.max'),
	location: yup.string().required('location.required').max(100, 'location.max'),
	day: yup.string().required('day.required'),
	month: yup.string().required('month.required'),
	year: yup.string().required('year.required'),
});
